<template>
  <div
    class="relative w-full border-b border-default/10"
    @mouseover="setCarouselButtonHover(true)"
    @mouseleave="setCarouselButtonHover(false)"
  >
    <LoadingWithSlot
      :is-loading="isLoading"
      :height="isMobile ? 160 : 320"
    >
      <div
        v-if="isAutoCarousel"
        class="carousel-button-container left"
      >
        <EpIconButton
          class="carousel-button"
          icon-name="keyboard_arrow_left"
          :icon-size="20"
          type="line"
          @click="goPrevSlide"
        />
      </div>
      <Carousel
        class="relative w-full"
        ref="bannerCarousel"
        :items-to-show="1"
        wrap-around
        pause-autoplay-on-hover
        :autoplay="(isAutoCarousel && !isCarouselHover) ? 5000 : 0"
        :mouse-drag="isAutoCarousel"
        :touch-drag="isAutoCarousel"
      >
        <Slide
          v-for="(featured, index) in data"
          :key="index"
        >
          <HomeBannerItem :item="featured" />
        </Slide>
      </Carousel>
      <div
        v-if="isAutoCarousel"
        class="carousel-button-container right"
      >
        <EpIconButton
          class="carousel-button"
          icon-name="keyboard_arrow_right"
          :icon-size="20"
          type="line"
          @click="goNextSlide"
        />
      </div>
    </LoadingWithSlot>
  </div>
</template>

<script setup lang="ts">
import { Carousel, Slide } from 'vue3-carousel'

import { useGetHomeBannerList } from '~/api/service/general.service'
import HomeBannerItem from '~/components/@pages/home/HomeBannerItem.vue'
import EpIconButton from '~/components/button/EpIconButton.vue'
import { useMedia } from '~/composables/useMedia'

const { data, isLoading } = useGetHomeBannerList()
const { isMobile } = useMedia()

const bannerCarousel = ref(null)

const isAutoCarousel = computed(() => {
  if (!data.value) {
    return false
  }
  return data.value?.length > 1
})

const goPrevSlide = () => {
  if (!bannerCarousel.value) {
    return
  }
  bannerCarousel.value.prev()
}

const goNextSlide = () => {
  if (!bannerCarousel.value) {
    return
  }
  bannerCarousel.value.next()
}

const isCarouselHover = ref(false)

const setCarouselButtonHover = (value: boolean) => {
  isCarouselHover.value = value
}
</script>

<style scoped lang="scss">
.carousel-button-container {
  @apply absolute top-0 w-48 h-full from-black to-transparent flex items-center px-8 z-40 pointer-events-none;

  @include mobile {
    @apply from-transparent w-24 px-2;
  }

  &.left {
    @apply left-0 bg-gradient-to-r justify-start;
  }

  &.right {
    @apply right-0 bg-gradient-to-l justify-end;
  }

  .carousel-button {
    @apply pointer-events-auto;
  }
}
</style>